export class WindowProvider {
    static getWindow() {
        return window;
    }
}
//# sourceMappingURL=windowProvider.js.map